export default "__VITE_ASSET__DlGv4pe$__"